module.exports = __webpack_public_path__ + "img/bx-right-arrow-alt-white.f3e2ded1.svg";